/** @jsxImportSource @emotion/react */
import { MenuOverwrite } from "../models/Menus";
import { ListItemSelector } from "../../../components/ListItemSelector";
import { css } from "@emotion/react";
import { MenuOverwriteScheduleLabel } from "./MenuOverwriteScheduleLabel";
import { OverwriteMenuModal } from "./OverwriteMenuModal";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { StyledText } from "../../../assets/typography/typography";
import { colors } from "../../../components/colors";
import { useSearchParamsManipulation } from "../../../hooks/use-searchparams-manipulation";
import { StatusIndicator } from "../../../components/StatusIndicator";

type Props = {
  overwrite: MenuOverwrite;
};

const childrenStyle = css`
  display: block;
  width: 100%;
`;

const lowerSectionContentWrapperStyle = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const statusWrapperStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-right: 16px;
`;

export const EditMenuOverwriteSelector = ({ overwrite }: Props) => {
  const { option, setOption, removeOption } = useSearchParamsManipulation();

  return (
    <>
      <ListItemSelector
        title={overwrite.name}
        subtitle={overwrite.description ?? ""}
        onClick={() => setOption(overwrite.id)}
        onClickCtaText="Edit"
        rightComponent={
          <div css={statusWrapperStyle}>
            <StatusIndicator backgroundColor={colors.successMedium} />
            <StyledText
              className="bodySubtextRegular mb-0"
              color={colors.textPrimary}
            >
              Active
            </StyledText>
          </div>
        }
        icon={<FontAwesomeIcon icon={solid("shuffle")} />}
      >
        <div css={lowerSectionContentWrapperStyle}>
          <StyledText
            className="bodyTextRegular mb-0"
            color={colors.textPrimary}
          >
            Availability:
          </StyledText>
          <div css={childrenStyle}>
            {overwrite.schedules
              .map((s) => ({
                endTime: s.toTime,
                startTime: s.fromTime,
                dayOfWeek: s.dayOfWeek,
              }))
              .map((schedule, index) => (
                <MenuOverwriteScheduleLabel
                  key={index}
                  schedule={schedule}
                  index={index}
                />
              ))}
          </div>
        </div>
      </ListItemSelector>
      <OverwriteMenuModal
        isOpen={option === overwrite.id}
        onClose={removeOption}
        overwrite={overwrite}
      />
    </>
  );
};
